import React from 'react';

import * as utils from "../../utils";

const AmazonAffiliatesGiftLink = React.createClass({

  render: function() {
    if (shouldNotShowAmazonGifting()) {
      return null;
    }

    const isMobile = utils.isMobile();
    const imgPath = '/assets/images/v2/web/amazon_affiliate_gifting_banner.png';
    const topText = Boolean(window.gift_registry_provider) ? "More Gift Ideas" : "Send the Gift";
    const topClassNames = `amazon-gift ${this.props.compactVersion ? "compact-version" : "simple-shadowbox"}${isMobile ? " mobile" : ""}`;
    const linkUrl = window.evite_event.options.gifting_link || 'https://www.amazon.com/dp/B01LXC12GI/ref=nav_timeline_asin?_encoding=UTF8&psc=1&_encoding=UTF8&tag=giftcardtest17-20&linkCode=ur2&linkId=6d55845269dc165e9ee758cccfd03257&camp=1789&creative=9325'

    if (this.props.compactVersion) {
      // this is the compact version - currently used on the RSVP tab
      return (
        <div className={topClassNames} id="amazon-gifting">
          <div className="gift-icon">
            <div className="icon-holder icon-gifts"></div>
          </div>
          <div className="gifts-text">
            <p id="send-gift-message"><strong>Send your gift now:</strong> It's super simple!</p>
            <p id="send-gift-link">
              <a
                href={linkUrl}
                className="start-gifting"
                target="_blank"
              >Send the Gift Now</a>
            </p>
          </div>
        </div>
      );
    }

    // not the compact version - banner image, etc.
    return (
      <div className={topClassNames} id="amazon-gifting">
        <div className="gift-icon">
          <div className="icon-holder icon-gifts"></div>
        </div>
        <div className="gifts-text">
          <h3>{topText}</h3>
        </div>

        <img src={imgPath} className="amazon-gifting-banner" />

        <p className="amazon-gifts-footer">
          <a
            href={linkUrl}
            className="start-gifting"
            target="_blank"
          >Start Gifting</a>
        </p>
      </div>
    );
  }

});

function shouldNotShowAmazonGifting() {
  return window.donations_enabled || !window.evite_event.options.event_option_show_gifting;
}

export default AmazonAffiliatesGiftLink;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/amazon-affiliates-gift-link.es6